// const configObj = {
//   env: process.env.NODE_ENV,
//   development: {
//     ajaxUrl: "https://departed.szskapp.com/v1/"
//   },
//   production: {
//     ajaxUrl: "https://departed.szskapp.com/v1/"
//   },
//   test: {
//     ajaxUrl: "https://departed.szskapp.com/v1/"
//   }
// };

const configObj = {
  env: process.env.NODE_ENV,
  development: {
    ajaxUrl: "https://api.szskapp.com/"
  },
  production: {
    ajaxUrl: "https://api.szskapp.com/"
  },
  test: {
    ajaxUrl: "https://api.szskapp.com/"
  }
};

// const configObj = {
//   env: process.env.NODE_ENV,
//   development: {
//     ajaxUrl: "http://192.168.3.222:8010/"
//   },
//   production: {
//     ajaxUrl: "http://192.168.3.222:8010/"
//   },
//   test: {
//     ajaxUrl: "http://192.168.3.222:8010/"
//   }
// };
const config = configObj[configObj.env];
export default config;
